import { Linked } from "@type-r/models";
import React from "react";
import { DialogType } from "../details/dialogs";
import { CloseInvoicesDialog } from "./close";

export const ShowGeneralDialog = ({ $dialog, model }: {
    $dialog: Linked<DialogType>,
    model: any
  }) => {
    switch ($dialog.value) {
      case 'close':
        return <CloseInvoicesDialog
          $isOpen={ $dialog.equals('close') }
          invoices={ model }
        />;
      default:
        return <div />;
    }
  }